import baseIcon from "components/BaseIcon";

const svg = (
  <svg
    t="1621915478479"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="2750"
    width="200"
    height="200"
  >
    <path
      d="M661.333333 490.666667h-128v-128a21.333333 21.333333 0 0 0-42.666666 0v128h-128a21.333333 21.333333 0 0 0 0 42.666666h128v128a21.333333 21.333333 0 0 0 42.666666 0v-128h128a21.333333 21.333333 0 0 0 0-42.666666z"
      p-id="2751"
    ></path>
    <path
      d="M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A427.157333 427.157333 0 0 0 512 85.333333z m0 810.666667a384 384 0 1 1 384-384 384.426667 384.426667 0 0 1-384 384z"
      p-id="2752"
    ></path>
  </svg>
);

const Icon = baseIcon(svg);

export default Icon;
